import { Badge, Button } from '@artosera/ui';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import {
  useReglagesNewsletter,
  useBrancherWebhook,
  useSynchroniserNewsletter,
} from '../../api/newsletter.js';
import { galerieALaction } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { ErreurNewsletter } from './ErreurNewsletter.js';
import styles from './NewsletterPage.module.css';
export function ReglagesNewsletterTab() {
  const { t, i18n } = useTranslation(['regie', 'commun']);
  const { galerieSlug, galerie } = useShellContext();
  const lecture = useReglagesNewsletter(galerieSlug);
  const brancher = useBrancherWebhook(galerieSlug);
  const synchroniser = useSynchroniserNewsletter(galerieSlug);
  const r = lecture.data?.reglages;
  const date = (v: string) =>
    new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium', timeStyle: 'short' }).format(
      new Date(v),
    );
  return (
    <section className={styles.section} data-ui="newsletter-settings">
      <ErreurNewsletter erreur={lecture.error} />
      {r ? (
        <div className={styles.grille}>
          <article className={styles.carte}>
            <h2>Brevo</h2>
            <p>
              {t(
                `regie:newsletter.reglages.${r.connecteur.configure ? 'configure' : 'nonConfigure'}`,
              )}
            </p>
            {r.connecteur.mode === 'simule' ? (
              <Badge>{t('regie:newsletter.reglages.simule')}</Badge>
            ) : null}
            {r.connecteur.expediteur ? (
              <p>
                {r.connecteur.expediteur.nom} · {r.connecteur.expediteur.email}
              </p>
            ) : null}
            <p>
              <Link to={`/${galerieSlug}/reglages/connecteurs`}>
                {t('regie:newsletter.reglages.lienConnecteurs')}
              </Link>
            </p>
          </article>
          <article className={styles.carte}>
            <h2>{t('regie:newsletter.reglages.desinscriptions')}</h2>
            <p>
              {r.webhook.branche && r.webhook.brancheLe
                ? t('regie:newsletter.reglages.brancheLe', { date: date(r.webhook.brancheLe) })
                : t('regie:newsletter.reglages.nonBranche')}
            </p>
            {galerieALaction(galerie, 'newsletter:send') ? (
              <Button
                variant="secondary"
                disabled={!r.connecteur.configure || brancher.isPending || r.webhook.branche}
                onClick={() => brancher.mutate()}
              >
                {t('regie:newsletter.reglages.brancher')}
              </Button>
            ) : null}
            <ErreurNewsletter erreur={brancher.error} />
          </article>
          <article className={styles.carte}>
            <h2>{t('regie:newsletter.reglages.synchronisation')}</h2>
            {r.derniereSynchro ? (
              <>
                <p>{date(r.derniereSynchro.le)}</p>
                <p className={styles.chiffre}>
                  {t('regie:newsletter.reglages.bilan', r.derniereSynchro)}
                </p>
              </>
            ) : (
              <p>{t('regie:newsletter.reglages.jamais')}</p>
            )}
            {galerieALaction(galerie, 'newsletter:write') ? (
              <Button
                variant="secondary"
                disabled={synchroniser.isPending}
                onClick={() => synchroniser.mutate()}
              >
                {t('regie:newsletter.reglages.synchroniser')}
              </Button>
            ) : null}
            {synchroniser.isSuccess ? (
              <p role="status">{t('regie:newsletter.reglages.synchroDemandee')}</p>
            ) : null}
            <ErreurNewsletter erreur={synchroniser.error} />
          </article>
        </div>
      ) : null}
    </section>
  );
}
